import { Component, OnInit, OnChanges, ViewChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';
import { PyramidVO, SectionVO } from '../shared';

@Component({
  selector: 'app-grouped-barchart',
  templateUrl: './grouped-barchart.component.html',
  styleUrls: ['./grouped-barchart.component.css']
})
export class GroupedBarChartComponent implements OnInit {

  @ViewChild('groupedbarchart') private chartContainer: ElementRef;
  @Input('inputData') private inputData: any;
  private chart: any;
  private reportTitle: string;
  private width: number = 960;
  private height: number = 650;
  private margin: any = { top: 20, right: 20, bottom: 100, left: 40 };
  private legendRectSize: number = 18;
  private legendSpacing: number = 4;

  constructor() { }

  ngOnInit() {
    this.drawChart();
  }

  ngOnChanges() {
    if (this.chart) {
      this.updateChart();
    }
  }

  updateChart() {
    d3.select("svg").remove(); 
    this.width = 960;
    this.height = 650;
    this.margin = { top: 20, right: 20, bottom: 100, left: 40 };

    this.drawChart();
  }

drawChart() {

  let element = this.chartContainer.nativeElement;

  //this.width = element.offsetWidth - this.margin.left - this.margin.right;
  this.width = this.width - this.margin.left - this.margin.right;
  //this.height = element.offsetHeight - this.margin.top - this.margin.bottom;
  this.height = this.height - this.margin.top - this.margin.bottom;
  let svg = d3.select(element).append('svg')
    .attr('width', this.width)
    .attr('height', this.height)
    .attr("preserveAspectRatio", "xMinYMin meet")
    .attr("viewBox", "0 0 800 600")
    .classed("svg-content", true)
    .append("g");

        // chart plot area
  this.chart = svg.append('g')
  .attr('class', 'bars')
  .attr('transform', "translate(" + this.margin.left + "," + this.margin.top+ ")");

   // create scales
  var x0 = d3.scaleBand().rangeRound([0, this.width]).paddingInner(0.1);
  var x1 = d3.scaleBand().padding(0.05);

  var y = d3.scaleLinear()
            .rangeRound([this.height - this.margin.bottom + this.margin.top, 0]);

  var z = d3.scaleOrdinal()
            .range(["#4472c4", "#ed7d31", "#a5a5a5", "#ffc000", "#5b9bd5", "#70ad47", "#264478", "#9e480e", "#636363"]);

  console.log("Input Data" + this.inputData);          
  var data = JSON.parse(this.inputData);
  var keys = Object.keys(data[0]).slice(1);

  x0.domain(data.map(function (d) { return d.Month; }));
  x1.domain(keys).rangeRound([0, x0.bandwidth()]);
  y.domain([0, d3.max(data, function (d) { return d3.max(keys, function (key) { return d[key]; }); })]).nice();

        var bars = this.chart.append("g")
            .selectAll("g")
            .data(data)
            .enter().append("g")
            .attr("transform", function (d) { return "translate(" + x0(d.Month) + ",0)"; });

        bars.selectAll("rect")
            .data(function (d) { return keys.map(function (key) { return { key: key, value: d[key] }; }); })
            .enter().append("rect")
            .attr("class", "bar")
            .attr("x", function (d) { return x1(d.key); })
            .attr("y", function (d) { if(d.value == 0) { return 0;} else{ return y(d.value); } })
            .attr("width", x1.bandwidth())
            .attr("height", function (d) { if(d.value == 0) { return 0;} else{ return /*this.height*/ 450 - y(d.value); }})
            .attr("fill", function (d) { return z(d.key); });

        bars.selectAll("text")    
        .data(function (d) { return keys.map(function (key) { return { key: key, value: d[key] }; }); })
            .enter().append("text")
            .attr("class","label")
            .attr("x", (function(d) { return x1(d.key) + 10; }  ))
            .attr("y", function(d) { return y(d.value) - 10; })
            .attr("dy", ".75em")
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .text(function(d) { if(d.value >0) {return d.value;} else {return '';} });

            this.chart.append("g")
            .attr('class', 'axis axis-x')
            .attr("transform", "translate(0," + 450 + ")")
            .call(d3.axisBottom(x0));

            this.chart.append("g")
            .attr('class', 'axis axis-y')
            .call(d3.axisLeft(y).ticks(data.length-1))
            .append("text")
            .attr("x", -60)
            .attr("y", function() { if(y.ticks().pop() == 0) { return -35;} else{ return y(y.ticks().pop()) -35;} })
            .attr("dy", "0.32em")
            .attr("fill", "#000")
            .attr("font-weight", "bold")
            .attr("text-anchor", "start")
            .text("# of Participation")
            .attr("transform", function(d) {
              return "rotate(-90)" 
              });

        var legend = this.chart.append("g")
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .attr("text-anchor", "end")
            .attr("transform","translate(-"+ (this.width/2) + "," + 450 + ")")
            .selectAll("g")
            .data(keys.slice().reverse())
            .enter().append("g")
            .attr("transform", function (d, i) { 
              if(i%2 == 0) {
               return "translate("+ (450 - (i * 100)) +"," +  20 + ")"; 
              } else {
                return "translate("+ (450 - ( (i -1) * 100)) +"," +  60 + ")";
              }
            });

        legend.append("rect")
            .attr("x", this.width - 19)
            .attr("width", 19)
            .attr("height", 19)
            .attr("fill", z);

        legend.append("text")
            .attr("x", this.width - (this.legendRectSize + this.legendSpacing * 1.5)-10)
            .attr('y', this.legendRectSize - this.legendSpacing)
            .attr("dy", "0.32em")
            .text(function (d) { return d; });

}

}


// WEBPACK FOOTER //
// ./src/app/grouped-barchart/grouped-barchart.component.ts